import { cipo } from "cipo";

cipo.controller(
	"editScreenController",
	function (
		$scope,
		Message,
		MODAL,
		WorkflowScreen,
		info,
		contractId,
        screenId,
		uriParams,
		entityInstanceId,
        isDraftState,
        documentNumber,
        saveDocument,
        createURI,
        saveURI,
        moduleName,
		showSuccessMessage,
		$q,
		$mdDialog,
	) {
		$scope.modalInfo = MODAL;
		$scope.entityInstanceId = entityInstanceId;
		$scope.disabledBtn = false;
		$scope.actionBtnDisabled = false;
		$scope.screen = new WorkflowScreen({ screenId: screenId, contractId: contractId, isDraftState: isDraftState, entityInstanceId: entityInstanceId });
		$scope.moduleName = moduleName;
        $scope.isDraftState = isDraftState;
        $scope.documentNumber = documentNumber;
        $scope.saveDocument = saveDocument;
        $scope.createURI = createURI;
        $scope.saveURI = saveURI;

		$scope.screen.data = {
			fields: info.fields,
		};

		$scope.screen.setupForm($scope.isDraftState);

		$scope.updateTabInfo = function () {
			$scope.actionBtnDisabled = true;
            if ($scope.saveDocument) {
                $scope
                    .save()
                    .then(function (r) {
                        $mdDialog.hide(r);
                    })
                    .catch(function (e) {
                        console.error(e);
                    })
                    .finally(function () {
                        $scope.actionBtnDisabled = false;
                    });
            } else {
                $mdDialog.hide($scope.screen.valuesDictionary);
            }
		};

		$scope.cancelAction = function () {
			$mdDialog.cancel();
		};

		$scope.save = function () {
			var p = $q.defer();
			var greenLight = false;
			if ($scope.screen.form) {
				$scope.screen.form.validate();
				greenLight = $scope.screen.form.isValid;
			} else greenLight = true;
			if (greenLight) {
				$scope.disabledBtn = true;
				$scope.message = $scope.entityInstanceId ? "Saving started..." : "Adding new started...";

				if ($scope.screen.form) $scope.screen.form.loading = true;

				const dataURL = !$scope.entityInstanceId
					? $scope.createURI
					: $scope.saveURI;

				$scope.screen[dataURL.method](dataURL, {
					url: uriParams,
					urltype: "obj",
					body: {
						values: $scope.screen.valuesDictionary,
                        screenId: $scope.screen.screenId
					},
				})
					.then(function (r) {
						if (showSuccessMessage) {
							Message.info($scope.moduleName + ($scope.entityInstanceId ? " saved successfully" : " added successfully"));
						}
						p.resolve(r);
						$mdDialog.hide(r);
					})
					.catch(function (e) {
						console.error(e);
						p.reject(e);
						if ($scope.screen.form) $scope.screen.form.catch(e);
					})
					.finally(function () {
						if ($scope.screen.form) $scope.screen.form.loading = false;
						$scope.disabledBtn = false;
						$scope.message = "";
					});
			} else {
				p.reject();
			}

			return p.promise;
		};
	},
);
